import type { TileRunState } from "../../viewer/storage/runState.ts";
import TileContainer from "./preview/TileContainer";
import TileViewer from "./preview/TileViewer";

interface Props {
  runState: TileRunState;
}

export default function TileViewerContainer({ runState }: Props) {
  return (
    <TileContainer>
      <TileViewer runState={runState} />
    </TileContainer>
  );
}
